<template>
<div class="animated slideInRight">
    <div class="p-1 mb-5 mt-3 ml-3 mr-3">
        <div class="row">
            <div class="col">
                <div class="step-container">
                    <div class="steps step-1" :class="'' | getStepSegmentClass(0, step)">
                        <div class="icon">
                            <i class="fa fa-file-text-o"></i>
                        </div>
                        <p class="step-text">Review</p>
                    </div>
                    <div class="steps step-2" :class="'' | getStepSegmentClass(1, step)">
                        <div class="icon">
                            <i class="fa fa-list"></i>
                        </div>
                        <p class="step-text">Items</p>
                    </div>
                    <div class="steps step-3" :class="'' | getStepSegmentClass(2, step)">
                        <div class="icon">
                            <i class="fa fa-calendar"></i>
                        </div>
                        <p class="step-text">Schedule</p>
                    </div>
                    <div class="steps step-4" :class="'' | getStepSegmentClass(3, step)">
                        <div class="icon">
                            <i class="fa fa-print"></i>
                        </div>
                        <p class="step-text">Print</p>
                    </div>
                    <div class="steps step-5" :class="'' | getStepSegmentClass(4, step)">
                        <div class="icon">
                            <i class="fa fa-check"></i>
                        </div>
                        <p class="step-text">Complete</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'StepPrint',
        props: ['step'],
        data () {
            return {}
        },
        filters: {
            /**
             * Get Step Segment Class
             *
             * @param String originalClass This is the original class. Usually pased as empty though.
             * @param Int checkingStep The step we're outputting and deciding how to display it
             * @param Int step The actual step (passed as attr as we can't use $this inside filters)
             * @return String Returns a string of all the classes we require spaced out
             */
            getStepSegmentClass: function (originalClass, checkingStep, step) {
                let classes = []
                if (checkingStep === step) {
                    classes.push('is-active')
                    classes.push('animated')
                    classes.push('rubberBand')
                    classes.push('slow')
                } else if (checkingStep < step) {
                    classes.push('is-hollow')
                }
                return classes.join(' ')
            }
        },
        computed: {},
        methods: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .step-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        color: #adb5bd;
        .steps {
            border: 1px solid #adb5bd;
            width: 75px;
            height: 75px;
            border-radius: 50%;
            display: flex;
            flex-flow: column nowrap;
            justify-content: flex-end;
            align-items: center;
            position: relative;
            .icon {
                font-size: 1.5rem;
                .fa {
                    vertical-align: middle;
                }
            }
            .step-text {
                font-size: 0.8rem;
            }
        }
        .is-active, .is-hollow {
            background: #2e7bcc;
            border: 1px solid transparent;
            color: white;
            &.icon {
            }
            +.step-text {
                color: white;
            }
        }
        .is-hollow {
            &:after {
                content: "";
                background-color: #2e7bcc;
                position:absolute;
                width: 230px;
                height: 20px;
                top:40%;
                left: 40%;
                bottom:0px;
                z-index:-9;
            }
        }
        @media (min-width: 320px) and (max-width: 800px) {
            .is-hollow {
                &:after {
                    background-color: transparent;
                    width: 0px;
                    height: 0px;
                }
            }
        }
    }
</style>
